export enum StaticFilterType {
  all = 'all',
  my = 'my',
  tracked = 'tracked',
  archived = 'archived',
}
